import { AutogiroStatus } from 'src/modules/member/models/member';

export enum AutogiroPeriodicity {
  OneMonth = 1,
  TwoMonths = 2,
  ThreeMonths = 3,
  FourMonths = 4,
  SixMonths = 5,
  TwelveMonths = 6,
}

export const displayAutogiroStatus = (status: AutogiroStatus, t: (n: string) => string) => {
  if (status && status.periodicity === AutogiroPeriodicity.OneMonth) {
    return t('member:autogiro.month');
  }
  if (status && status.periodicity === AutogiroPeriodicity.TwoMonths) {
    return t('member:autogiro.twoMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.ThreeMonths) {
    return t('member:autogiro.threeMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.FourMonths) {
    return t('member:autogiro.fourMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.SixMonths) {
    return t('member:autogiro.sixMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.TwelveMonths) {
    return t('member:autogiro.year');
  }
  return t('member:noAutogiro');
};

export const displayAutogiroPeriodicityOnly = (status: AutogiroStatus, t: (n: string) => string) => {
  if (status && status.periodicity === AutogiroPeriodicity.OneMonth) {
    return t('member:autogiroPeriod.month');
  }
  if (status && status.periodicity === AutogiroPeriodicity.TwoMonths) {
    return t('member:autogiroPeriod.twoMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.ThreeMonths) {
    return t('member:autogiroPeriod.threeMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.FourMonths) {
    return t('member:autogiroPeriod.fourMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.SixMonths) {
    return t('member:autogiroPeriod.sixMonths');
  }
  if (status && status.periodicity === AutogiroPeriodicity.TwelveMonths) {
    return t('member:autogiroPeriod.year');
  }
  return t('member:noAutogiro');
};
